import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
// import { selectIsAuthenticated } from 'features/auth/authSlice'
// import { useSelector } from 'react-redux'
// import { useLoginMutation, useProtectedMutation } from 'features/auth/auth'
import './login.scss';


import { useNavigate } from "react-router"


import AuthService from '../features/auth/auth.service'

function Login() {

  const isAuthenticated = AuthService.selectIsAuthenticated

  let navigate = useNavigate();


  const [ username, setUsername ] = useState('')
  const [ password, setPass ] = useState('')


  const loginUser = async() =>{
      AuthService.login( username, password).then(
        () => {
          // toast('lo hiciste')
          window.location.reload();
          // navigate('/profile')
        },
        error => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          toast(resMessage)

        }
      );
  }


  const setearUsername = (event:any)=> setUsername(event.target.value)
  const setearContrasena = (event:any)=> setPass(event.target.value)


  useEffect(() => {
    if(AuthService.selectIsAuthenticated){
      navigate('/profile')
    }
  }, [ navigate ]);



  return (
    <div className="content">

      {isAuthenticated ? (
        <>
          <p>You're logged-in.</p>

        </>
      ) : (
        <>

<div className="sidenav">
   <div className="login-main-text text-center">
       <img src="assets/images/gestimas.png" alt="" width="60%" />
   </div>
</div>
<div className="main">
   <div className="col-md-6 col-sm-12">
      <div className="login-form">
         <form>

           <h2>Acceso al Sistema</h2>


            <div className="form-group">
               <label>Usuario</label>
               <input type="text" className="form-control" onChange={ setearUsername } onKeyPress={(e:any)=>{if(e.key==='Enter')loginUser();}} />
            </div>
            <div className="form-group">
               <label>Contraseña</label>
               <input type="password" className="form-control" onChange={ setearContrasena } onKeyPress={(e:any)=>{if(e.key==='Enter')loginUser();}} />
            </div>

              <button type="button" className="btn wu btn-primary" onClick={loginUser}>Entrar al Sistema</button>

         </form>
      </div>
   </div>
</div>



        </>
      )}

    </div>
  )
}

export default Login




          // <p>You're in the Home page. Login to visit protected pages.</p>
          // <button className="button" onClick={loginUser}>
          //   Login
          // </button>